import { inject } from '@angular/core';
import { CanActivateFn, createUrlTreeFromSnapshot, UrlTree } from '@angular/router';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { IAppState } from '../../../app/app.reducer';
import { selectFreightTypesEnabled } from '../user.reducer';

export const accessToSpecialisedFreightGuard: CanActivateFn = (route, state) => {
  const store$ = inject(Store<IAppState>);

  return new Observable<boolean | UrlTree>((observer) => {
    store$.select(selectFreightTypesEnabled).subscribe((freightTypesEnabled) => {
      if (freightTypesEnabled?.specialisedFreightEnabled) {
        observer.next(true);
        observer.complete();
      } else {
        observer.next(createUrlTreeFromSnapshot(route, ['']));
        observer.complete();
      }
    });
  });
};
